import { withBOPISProps } from 'viewModel/productPage/deliveryOptions/bopis/withBOPISProps';
import BOPIS from 'components/ProductPage/DeliveryOptions/BOPIS/BOPIS';

export default withBOPISProps(BOPIS);
